import { ArrowRight, Wrench, ListOrdered, Zap } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { scrollToSection } from "@/lib/scroll";

const PERKS = [
  { icon: Wrench, label: "Free equipment & installation" },
  { icon: ListOrdered, label: "First pick of the product menu" },
  { icon: Zap, label: "Priority same-day service — always" },
];

export default function FoundingLocations() {
  return (
    <section id="founding" data-testid="founding-locations-section" className="relative py-12 lg:py-16">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-[2.5rem] bg-[#1B365D] px-7 py-14 text-center sm:px-12 lg:py-20">
            <div
              aria-hidden="true"
              className="absolute -left-24 -top-24 h-72 w-72 rounded-full bg-[#C9A227]/15 blur-[90px]"
            />
            <div
              aria-hidden="true"
              className="absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-[#C9A227]/10 blur-[90px]"
            />
            <div className="relative">
              <span
                data-testid="founding-badge"
                className="inline-flex items-center gap-2 rounded-full border border-[#C9A227]/50 bg-[#C9A227]/12 px-4 py-2 font-mono text-[11px] font-semibold uppercase tracking-[0.24em] text-[#E5C558]"
              >
                <span className="h-1.5 w-1.5 rounded-full bg-[#C9A227]" />
                Founding partner program
              </span>
              <h2 className="mx-auto mt-6 max-w-2xl font-display text-3xl font-extrabold tracking-tight text-[#FBF7EF] sm:text-4xl lg:text-5xl">
                Be one of the first SnackSavvy locations in Manitoba.
              </h2>
              <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-[#FBF7EF]/70 sm:text-lg">
                We're placing our first machines now. Founding locations get our
                best treatment — and it stays that way for the life of your machine.
              </p>
              <div className="mx-auto mt-9 flex max-w-3xl flex-wrap justify-center gap-3">
                {PERKS.map((p) => (
                  <span
                    key={p.label}
                    className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/8 px-4 py-2.5 text-sm font-medium text-[#FBF7EF]"
                  >
                    <p.icon className="h-4 w-4 text-[#E5C558]" />
                    {p.label}
                  </span>
                ))}
              </div>
              <button
                data-testid="founding-cta"
                onClick={() => scrollToSection("quote")}
                className="group mt-10 inline-flex items-center gap-2.5 rounded-full bg-[#C9A227] px-7 py-4 font-semibold text-[#1B365D] transition-all hover:-translate-y-0.5 hover:bg-[#D9B23C] hover:shadow-[0_16px_44px_rgba(201,162,39,0.35)]"
              >
                Claim a founding spot
                <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
              </button>
              <p data-testid="founding-fairplay-note" className="mx-auto mt-6 max-w-xl text-xs leading-relaxed text-[#FBF7EF]/55">
                Fair play: equipment, delivery, standard installation and service are
                always free. If a space needs major electrical or construction work —
                usually only for micro markets — we flag it in the free site survey
                and those contractor costs are quoted separately, approved by you
                before any work happens.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
